export function activeKeyCount(keys: readonly { status: string }[]): number {
    return keys.filter((key) => key.status === "active").length;
}

interface RotationKey {
    id: string;
    status: string;
    replacesKeyId: string | null;
}

export function canRotateKey(key: RotationKey, keys: readonly RotationKey[]): boolean {
    if (key.status !== "active") return false;
    if (!key.replacesKeyId) return true;
    const predecessor = keys.find((candidate) => candidate.id === key.replacesKeyId);
    return predecessor?.status !== "rotating";
}

export function formatApiKeyDate(value: string | null): string {
    if (!value) return "Never";
    return new Intl.DateTimeFormat(undefined, {
        dateStyle: "medium",
        timeStyle: "short"
    }).format(new Date(value));
}

export function expiryInputToUtc(value: string): string | null {
    if (!value) return null;
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date.toISOString() : null;
}
